import { useEffect, useRef, useState } from 'react';
import { fetchReport, reportRequest } from './reportRequest';

// A response belongs to one case and one selected scope. Never reuse Redux or
// local-storage case data when the request changes or fails.
export default function useReportData(caseId, search, enabled = true) {
  const sequence = useRef(0);
  const key = `${enabled}:${caseId}:${search}`;
  const [state, setState] = useState({ key, loading: true });
  useEffect(() => {
    const current = ++sequence.current;
    const controller = new AbortController();
    if (!enabled) return () => controller.abort();
    setState({ key, loading: true });
    let request;
    try { request = reportRequest(caseId, search); }
    catch (error) { setState({ key, loading: false, error: error.message }); return () => controller.abort(); }
    fetchReport(request, controller.signal).then(report => {
      if (current === sequence.current && !controller.signal.aborted) setState({ key, loading: false, report });
    }).catch(error => {
      if (current === sequence.current && !controller.signal.aborted) setState({ key, loading: false, error: error.message });
    });
    return () => { controller.abort(); sequence.current += 1; };
  }, [caseId, search, key, enabled]);
  if (!enabled) return { key, loading: false };
  return state.key === key ? state : { key, loading: true };
}
